import React, { Fragment, useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import * as Yup from "yup";
import CustomInput from "../../../Custom/CustomInput";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Label, Row } from "reactstrap";
import CustomFlatpickr from "../../../Custom/CustomFlatpicker";
import { InputGroup, Modal } from "react-bootstrap";
import CustomSelect from "../../../Custom/CustomSelect";
import CustomPhoneInput from "../../../Custom/CustomPhoneInput";
import {
  POST_OrderBookingEquipmentPDCSearchByOrderBookingNo,
  POST_GetOrderBookingEquipmentPDCDetailsByID,
  POST_AdminOrderBookingEquipmentPDCDetailsInsert,
  POST_AdminOrderBookingEquipmentPDCDetailsUpdate,
  POST_AdminStaffsListDDLByCompanyID,
  POST_AdminOrderBookingEquipmentPDCFileInsert,
} from "../../../Helper/url_helper";
import { post, postFormData } from "../../../Helper/api_helper";
import { t } from "i18next";
import { Spin } from "antd";
import swal from "sweetalert";
import ModalOrderBookingDetail from "../../../Custom/ModalOrderBookingDetail";
import moment from "moment";

const AddEquipmentPDC = () => {
  const { OrderBookingEquipmentPDCDetailIDEncryptParam } = useParams();

  const history = useHistory();

  const [orderDetailModal, setOrderDetailModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [orderBookingID, setOrderBookingID] = useState("");
  const [staffOptions, setStaffOptions] = useState([]);

  const [file, setFile] = useState(null);
  const [fileKey, setFileKey] = useState();
  const [viewPDC, setViewPDC] = useState(null);
  const [validationPDCFile, setValidationPDCFile] = useState("");

  const [countryGivenBy, setCountryGivenBy] = useState("in");
  const [countryReturnTo, setCountryReturnTo] = useState("in");

  var objLogin = JSON.parse(localStorage.getItem("userDetails"));

  const validationSchema = Yup.object().shape({
    OrderBookingNo: Yup.string().required(
      "Order Booking No. is required field"
    ),
    PDCReceivedDate: Yup.string().required(
      "PDC Received Date is required field"
    ),
    PDCRemarks: Yup.string().required("PDC Remark is required field"),
    PDCRecievedByStaff: Yup.string().required(
      "PDC Recieved By Staff is required field"
    ),
    PDCGivenBy: Yup.string().required("PDC Given By is required field"),
    PDCGivenByMobileNo: Yup.string().required(
      "PDC Given By Mobile No is required field"
    ),
    EquipmentDepositAmount: Yup.number()
      .positive("Equipment Deposit Amount is requried field")
      .integer("Equipment Deposit Amount is requried field")
      .required("Equipment Deposit Amount is requried field"),
    PDCReturnDate: Yup.string().when("IsPDCReturned", {
      is: true,
      then: Yup.string().required("PDC Return Date is required"),
    }),
    PDCReturnRemark: Yup.string().when("IsPDCReturned", {
      is: true,
      then: Yup.string().required("PDC Return Remark is required"),
    }),
    PDCReturnByStaff: Yup.string().when("IsPDCReturned", {
      is: true,
      then: Yup.string().required("PDC Return By Staff is required"),
    }),
    PDCReturnTo: Yup.string().when("IsPDCReturned", {
      is: true,
      then: Yup.string().required("PDC Return To is required"),
    }),
    PDCReturnToMobileNo: Yup.string().when("IsPDCReturned", {
      is: true,
      then: Yup.string().required("PDC Return To MobileNo is required"),
    }),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CompanyID: objLogin?.CompanyIDEncrypt,
      OrderBookingNo: "",
      PDCReceivedDate: "",
      PDCRemarks: "",
      PDCReturnDate: "",
      PDCReturnRemark: "",
      PDCRecievedByStaff: "",
      PDCGivenBy: "",
      PDCGivenByMobileNo: "",
      IsPDCReturned: false,
      PDCReturnByStaff: "",
      PDCReturnTo: "",
      PDCReturnToMobileNo: "",
      EquipmentDepositAmount: "",
      PatientNo: "",
      PatientName: "",
      CountryCodeGivenBy: "+91",
      CountryCodeReturnTo: "+91",
    },
    validateOnBlur: false,
  });

  const {
    setValues,
    setFieldValue,
    values: {
      IsPDCReturned,
      PatientNo,
      PatientName,
      OrderBookingNo,
      CompanyID,
      CountryCodeGivenBy,
      CountryCodeReturnTo,
      PDCReceivedDate,
      PDCReturnDate,
    },
  } = formik;

  const handleChangeIsPDCReturned = (event) => {
    setFieldValue("IsPDCReturned", event.target.checked);
  };

  useEffect(() => {
    getStaffList();
    if (OrderBookingEquipmentPDCDetailIDEncryptParam) {
      setIsLoading(true);
      post(POST_GetOrderBookingEquipmentPDCDetailsByID, {
        OrderBookingEquipmentPDCDetailID: window.atob(
          OrderBookingEquipmentPDCDetailIDEncryptParam
        ),
      }).then((res) => {
        if (res.IsSuccess) {
          setValues({
            OrderBookingNo: res.OrderBookingNo,
            PDCReceivedDate: new Date(res.PDCReceivedDate),
            PDCRemarks: res.PDCRemarks,
            PDCReturnDate: res.PDCReturnDate ? new Date(res.PDCReturnDate) : "",
            PDCReturnRemark: res.PDCRetrunRemarks,
            PDCRecievedByStaff: res.PDCReceivedByEncrypt,
            PDCGivenBy: res.PDCGivenBy,
            PDCGivenByMobileNo: res.PDCGivenByMobileNo,
            IsPDCReturned: res.IsPDCReturned,
            PDCReturnByStaff: res.PDCReturnedByEncrypt,
            PDCReturnTo: res.PDCReturnTo,
            PDCReturnToMobileNo: res.PDCReturnToMobileNo,
            EquipmentDepositAmount: res.EquipmentDepositAmount,
            PatientNo: res.PatientNo,
            PatientName: res.PatientName,
            CountryCodeGivenBy: res.PDCGivenByCountryCode,
            CountryCodeReturnTo: res.PDCReturnCountryCode,
          });
          setViewPDC(res.PDCFilePath);
          setOrderBookingID(res.OrderBookingIDEncrypt);
        }
      });
      setIsLoading(false);
    }
  }, []);

  const getStaffList = async () => {
    await post(POST_AdminStaffsListDDLByCompanyID, {
      CompanyIDEncrypt: CompanyID,
    })
      .then((res) => {
        if (res.IsSuccess) {
          setStaffOptions(
            res.StaffsList.map((item) => ({
              label: item.StaffName,
              value: item.StaffIDEncrypt,
            }))
          );
        }
      })
      .catch((error) => console.log(error));
  };

  const uploadFile = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /(\.|\/)(jpe?g|png|webp|pdf|svg|gif|ico)$/;
      if (!file.type.match(pattern)) {
        setFile(null);
        setFileKey(Math.random().toString(9).substring(2, 9));
        swal("", "Select valid file format (PDF/Image)", "warning");
      } else {
        setFile(file);
        setFileKey(Math.random().toString(9).substring(2, 9));
        setValidationPDCFile("");
      }
    } else {
      setFile(null);
      setFileKey(Math.random().toString(9).substring(2, 9));
    }
  };

  const handleValidSubmit = (values, { setSubmitting }) => {
    if (orderBookingID === "") {
      swal({
        title: "warning",
        text: "Order Booking No. is Invalid...!",
        icon: "warning",
        button: "OK",
      });
      return;
    }
    if (file === null && viewPDC === null) {
      setValidationPDCFile("PDC File is required");
      return false;
    }
    setIsLoading(true);
    const data = {
      OrderBookingIDEncrypt: orderBookingID ? orderBookingID : "",
      OrderBookingEquipmentPDCDetailIDEncrypt:
        OrderBookingEquipmentPDCDetailIDEncryptParam
          ? window.atob(OrderBookingEquipmentPDCDetailIDEncryptParam)
          : "",
      PDCReceivedDate: `${moment(values.PDCReceivedDate)
        .format("YYYY-MM-DD")
        .replace(/^\-/, "")} 00:00:00.000`,
      PDCRemarks: values.PDCRemarks,
      PDCReceivedByEncrypt: values.PDCRecievedByStaff,
      IsPDCReturned: IsPDCReturned,
      PDCReturnDate: IsPDCReturned
        ? `${moment(values.PDCReturnDate)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")} 00:00:00.000`
        : "",
      PDCRetrunRemarks: IsPDCReturned ? values.PDCReturnRemark : "",
      PDCReturnedByEncrypt: IsPDCReturned ? values.PDCReturnByStaff : "",
      EquipmentDepositAmount: values.EquipmentDepositAmount,
      PDCGivenBy: values.PDCGivenBy,
      PDCGivenByMobileNo: values.PDCGivenByMobileNo,
      PDCReturnTo: IsPDCReturned ? values.PDCReturnTo : "",
      PDCReturnToMobileNo: IsPDCReturned ? values.PDCReturnToMobileNo : "",
      PDCGivenByCountryCode: "+" + CountryCodeGivenBy.replace(/\+/g, ""),
      PDCReturnCountryCode: "+" + CountryCodeReturnTo.replace(/\+/g, ""),
    };

    post(
      OrderBookingEquipmentPDCDetailIDEncryptParam
        ? POST_AdminOrderBookingEquipmentPDCDetailsUpdate
        : POST_AdminOrderBookingEquipmentPDCDetailsInsert,
      data
    )
      .then((response) => {
        if (response.IsSuccess) {
          swal({
            title: "Success",
            text: t(response.MessageCode),
            icon: "success",
            button: "OK",
          });
          SaveUploadFile(
            OrderBookingEquipmentPDCDetailIDEncryptParam
              ? window.atob(OrderBookingEquipmentPDCDetailIDEncryptParam)
              : response.EncryptID
          );
          formik.resetForm();
          history.push("/equipment-pdc-list");
        } else {
          swal({
            title: "Error",
            text: t(response.MessageCode),
            icon: "error",
            button: "OK",
          });
          formik.resetForm();
          setFile(null);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setIsLoading(false);
  };

  const SaveUploadFile = (oID) => {
    if (file) {
      setIsLoading(true);
      let formData = new FormData();
      formData.append("EncryptOrderBookingEquipmentPDCDetailID", oID);
      formData.append("PDCFilePath", file);

      postFormData(POST_AdminOrderBookingEquipmentPDCFileInsert, formData)
        .then((response) => {
          if (response.IsSuccess) {
            setIsLoading(false);
          } else {
            console.log(response);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    if (!PDCReceivedDate) {
      setFieldValue("PDCReceivedDate", "");
    }
  }, [PDCReceivedDate]);

  useEffect(() => {
    if (!PDCReturnDate) {
      setFieldValue("PDCReturnDate", "");
    }
  }, [PDCReturnDate]);

  useEffect(() => {
    if (!OrderBookingNo) {
      formik.resetForm();
      setOrderBookingID("");
    }
  }, [OrderBookingNo]);

  const getEquipmentPDCDetailByOrderBookingNo = async () => {
    if (OrderBookingNo) {
      setIsLoading(true);
      await post(POST_OrderBookingEquipmentPDCSearchByOrderBookingNo, {
        OrderBookingNo: OrderBookingNo,
        CompanyID: CompanyID,
      }).then((res) => {
        if (res.IsSuccess) {
          setFieldValue("PatientName", res.PatientName);
          setFieldValue("PatientNo", res.PatientNo);
          setFieldValue("EquipmentDepositAmount", res.EquipmentDeposit);
          setOrderBookingID(res.OrderBookingIDEncrypt);
        } else {
          swal({
            // title: "warning",
            text: t(res.MessageCode),
            icon: "warning",
            button: "OK",
          });
          formik.resetForm();
        }
      });
      setIsLoading(false);
    } else {
      swal({
        // title: "Error",
        text: "Order Booking No. is required field",
        icon: "warning",
        button: "OK",
      });
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <PageTitle
          activeMenu={
            OrderBookingEquipmentPDCDetailIDEncryptParam
              ? "Edit Equipment PDC"
              : "Add Equipment PDC"
          }
          motherMenu={<Link to="/equipment-pdc-list">Equipment PDC</Link>}
        />
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="basic-form">
                  <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                      <Row>
                        <Col lg={4}>
                          <Field
                            label={"Order Booking No."}
                            name="OrderBookingNo"
                            placeholder={"Search here...."}
                            component={CustomInput}
                            maxLength={15}
                            disabled={
                              OrderBookingEquipmentPDCDetailIDEncryptParam
                                ? true
                                : false
                            }
                          />
                        </Col>
                        {!OrderBookingEquipmentPDCDetailIDEncryptParam ? (
                          <Col lg={2}>
                            <div className="mb-3">
                              <Label>&nbsp;</Label>
                              <InputGroup>
                                <button
                                  type="button"
                                  className="btn mt-1 mr-2 btn-xs btn-primary"
                                  onClick={() => {
                                    getEquipmentPDCDetailByOrderBookingNo();
                                  }}
                                >
                                  Search
                                </button>
                              </InputGroup>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}
                      </Row>
                      <hr></hr>
                      {orderBookingID ? (
                        <>
                          <Row>
                            <Col lg={3}>
                              <b>Patient No.</b> : &nbsp;&nbsp; {PatientNo}
                            </Col>
                            <Col lg={6}>
                              <b>Patient Name</b> : &nbsp;&nbsp; {PatientName}
                            </Col>
                            <Col lg={3} style={{ textAlign: "right" }}>
                              <button
                                type="button"
                                className="btn mr-2 btn-xs btn-light"
                                onClick={() => {
                                  setOrderDetailModal(true);
                                }}
                              >
                                View Order Detail
                              </button>
                            </Col>
                          </Row>

                          <hr></hr>
                        </>
                      ) : (
                        ""
                      )}
                      <Row>
                        <Col lg={3}>
                          <Field
                            type="number"
                            label={"Equipment Deposit Amount"}
                            name="EquipmentDepositAmount"
                            placeholder={"Deposit Amount"}
                            component={CustomInput}
                            min={0}
                            onChange={(e) => {
                              setFieldValue(
                                "EquipmentDepositAmount",
                                e.target.value.slice(0, 7)
                              );
                            }}
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label={"PDC Received Date"}
                            name="PDCReceivedDate"
                            placeholder={"Select PDC Received Date"}
                            component={CustomFlatpickr}
                            options={{
                              altInput: true,
                              altFormat: "j-M-Y",
                              dateFormat: "d-m-Y",
                            }}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Label>
                            Upload PDC File Path{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <div
                            className="input-group mb-3"
                            style={{ zIndex: "0" }}
                          >
                            <div className="custom-file">
                              <input
                                type="file"
                                className="custom-file-input"
                                name="uploadFile"
                                onChange={(e) => {
                                  uploadFile(e);
                                }}
                                key={fileKey || ""}
                              />
                              <label
                                className="custom-file-label"
                                htmlFor="uploadFile"
                              >
                                {file ? file?.name : "Choose file"}
                              </label>
                            </div>
                          </div>
                          <span
                            style={{
                              color: "#ec4561",
                              marginTop: "0.25rem",
                              fontSize: "80%",
                            }}
                          >
                            {validationPDCFile}
                          </span>
                        </Col>
                        {viewPDC ? (
                          <Col lg={2}>
                            <Label>&nbsp;</Label>
                            <div className="input-group mb-3">
                              <Link
                                className="btn btn-light shadow sharp mr-1"
                                onClick={() => {
                                  window.open(viewPDC, "_blank");
                                }}
                              >
                                View PDC
                              </Link>
                            </div>
                          </Col>
                        ) : (
                          ""
                        )}
                        <Col lg={10}>
                          <Field
                            label={"PDC Remark"}
                            name="PDCRemarks"
                            placeholder={"Enter PDC Remark"}
                            component={CustomInput}
                            maxLength={200}
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label={"PDC Recieved By Staff"}
                            name="PDCRecievedByStaff"
                            placeholder={"PDC Recieved By Staff"}
                            component={CustomSelect}
                            options={staffOptions}
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label={"PDC Given By"}
                            name="PDCGivenBy"
                            placeholder={"Enter PDC Given By Name"}
                            component={CustomInput}
                            onChange={(e) => {
                              setFieldValue(
                                "PDCGivenBy",
                                e.target.value.replace(/[^A-Za-z ]/g, "")
                              );
                            }}
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label={"PDC Given By Mobile No."}
                            name="PDCGivenByMobileNo"
                            placeholder={"Enter Mobile No."}
                            country={countryGivenBy}
                            countryCode={CountryCodeGivenBy}
                            component={CustomPhoneInput}
                            onChange={(value, { countryCode, dialCode }) => {
                              setFieldValue("CountryCodeGivenBy", dialCode);
                              setFieldValue(
                                "PDCGivenByMobileNo",
                                value.substring(dialCode.toString().length)
                              );
                            }}
                            required
                          />
                        </Col>
                      </Row>
                      <hr></hr>
                      <Row>
                        <Col lg={3}>
                          <div
                            className="custom-control custom-checkbox mb-3 mt-1 checkbox-success"
                            style={{ zIndex: 0 }}
                          >
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="IsPDCReturned"
                              onChange={handleChangeIsPDCReturned}
                              checked={IsPDCReturned}
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="IsPDCReturned"
                            >
                              Is PDC Returned
                            </label>
                          </div>
                        </Col>
                        {IsPDCReturned ? (
                          <>
                            <Col lg={3}>
                              <Field
                                label={"PDC Return Date"}
                                name="PDCReturnDate"
                                placeholder={"Select PDC Return Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                                required={IsPDCReturned}
                              />
                            </Col>
                            <Col lg={6}>
                              <Field
                                label={"PDC Return Remark"}
                                name="PDCReturnRemark"
                                placeholder={"Enter PDC Return Remark"}
                                component={CustomInput}
                                maxLength={200}
                                required={IsPDCReturned}
                              />
                            </Col>
                            <Col lg={3}>
                              <Field
                                label={"PDC Return By Staff"}
                                name="PDCReturnByStaff"
                                placeholder={"PDC Return By Staff"}
                                component={CustomSelect}
                                options={staffOptions}
                                required={IsPDCReturned}
                              />
                            </Col>
                            <Col lg={3}>
                              <Field
                                label={"PDC Return To"}
                                name="PDCReturnTo"
                                placeholder={"Enter PDC Return To Name"}
                                component={CustomInput}
                                maxLength={200}
                                required={IsPDCReturned}
                                onChange={(e) => {
                                  setFieldValue(
                                    "PDCReturnTo",
                                    e.target.value.replace(/[^A-Za-z ]/g, "")
                                  );
                                }}
                              />
                            </Col>
                            <Col lg={3}>
                              <Field
                                label={"PDC Return To Mobile No."}
                                name="PDCReturnToMobileNo"
                                placeholder={"Enter Mobile No."}
                                country={countryReturnTo}
                                countryCode={CountryCodeReturnTo}
                                component={CustomPhoneInput}
                                onChange={(
                                  value,
                                  { countryCode, dialCode }
                                ) => {
                                  setFieldValue(
                                    "CountryCodeReturnTo",
                                    dialCode
                                  );
                                  setFieldValue(
                                    "PDCReturnToMobileNo",
                                    value.substring(dialCode.toString().length)
                                  );
                                }}
                                required={IsPDCReturned}
                              />
                            </Col>
                          </>
                        ) : (
                          ""
                        )}
                      </Row>
                      <hr></hr>
                      <button type="submit" className="btn mr-2 btn-primary">
                        Submit
                      </button>
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={(e) => {
                          history.goBack();
                        }}
                      >
                        Cancel
                      </button>
                    </Form>
                  </FormikProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          className="modal fade"
          show={orderDetailModal}
          onHide={setOrderDetailModal}
          size="xl"
        >
          <div className="modal-header">
            <h4 className="modal-title fs-20">Order Detail</h4>
            <button
              type="button"
              className="btn close"
              onClick={() => setOrderDetailModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <ModalOrderBookingDetail
              orderBookingID={orderBookingID}
              setOrderDetailModal={setOrderDetailModal}
            ></ModalOrderBookingDetail>
          </div>
        </Modal>
      </Spin>
    </Fragment>
  );
};

export default AddEquipmentPDC;
